export const RENDER_COMPONENT = 'RENDER_COMPONENT'
export const CLEAR_RENDER_COMPONENT = 'CLEAR_RENDER_COMPONENT'
